import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../store';
import { auth } from '../../firebase/config';
import HeadDashboard from './HeadDashboard';
import { fetchCompanyIdAndPsoInfo, fetchManagedPsos } from '../request_management/request_form/service/requestManagementService';

export default function RegionalHeadDashboard() {
    const pso = useAppSelector((s) => s.user.pso);
    const uid = auth.currentUser?.uid;
    const [companyId, setCompanyId] = useState<string | null>(null);
    const [psoId, setPsoId] = useState<string | null>(null);
    const [posFirestoreDocId, setPosFirestoreDocId] = useState<string | null>(null);
    const [psoDesignation, setPsoDesignation] = useState<string | null>(null);
    const [managedPsoIds, setManagedPsoIds] = useState<string[]>([]);
    const [managedReady, setManagedReady] = useState(false);
    const posDocPathId = posFirestoreDocId ?? uid ?? '';

    useEffect(() => {
        if (!uid) return;
        void (async () => {
            try {
                const companyInfo = await fetchCompanyIdAndPsoInfo(uid);
                if (companyInfo) {
                    setCompanyId(companyInfo.companyId);
                    setPsoId(companyInfo.psoId);
                    setPosFirestoreDocId(companyInfo.posDocId);
                    setPsoDesignation(companyInfo.psoDesignation);
                }
            } catch (err) {
                console.error('Regional dashboard company resolve failed:', err);
            }
        })();
    }, [uid]);

    useEffect(() => {
        if (!companyId || !psoId || !psoDesignation || !posDocPathId) return;
        setManagedReady(false);
        void (async () => {
            try {
                const ids = await fetchManagedPsos(companyId, psoId, psoDesignation, posDocPathId);
                setManagedPsoIds(ids);
            } catch (error) {
                console.error('Regional dashboard managed PSOs failed:', error);
                setManagedPsoIds([]);
            } finally {
                setManagedReady(true);
            }
        })();
    }, [companyId, psoId, psoDesignation, posDocPathId]);

    if (!uid || !companyId || !psoId || !psoDesignation || !posDocPathId || !managedReady) {
        return (
            <div className="space-y-6">
                <div className="h-8 w-64 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700" />
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="h-24 animate-pulse rounded-xl bg-gray-200 dark:bg-gray-700" />
                    ))}
                </div>
                <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
                    <div className="h-56 animate-pulse rounded-xl bg-gray-200 dark:bg-gray-700" />
                    <div className="h-56 animate-pulse rounded-xl bg-gray-200 dark:bg-gray-700" />
                </div>
            </div>
        );
    }

    return (
        <HeadDashboard
            managedPsoAuthIds={managedPsoIds}
            dashboardTitle="Regional dashboard"
            dashboardSubtitle={`Welcome, ${pso?.name || 'Regional lead'}. Metrics and surveys for your assigned PSOs.`}
        />
    );
}
